angular.module('tf.services')

    .config(function(){
        /* jshint ignore:start */
        (function(e,b){if(!b.__SV){var a,f,i,g;window.mixpanel=b;b._i=[];b.init=function(a,e,d){function f(b,h){var a=h.split(".");2==a.length&&(b=b[a[0]],h=a[1]);b[h]=function(){b.push([h].concat(Array.prototype.slice.call(arguments,0)))}}var c=b;"undefined"!==typeof d?c=b[d]=[]:d="mixpanel";c.people=c.people||[];c.toString=function(b){var a="mixpanel";"mixpanel"!==d&&(a+="."+d);b||(a+=" (stub)");return a};c.people.toString=function(){return c.toString(1)+".people (stub)"};i="disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user".split(" ");
                for(g=0;g<i.length;g++)f(c,i[g]);b._i.push([a,e,d])};b.__SV=1.2;a=e.createElement("script");a.type="text/javascript";a.async=!0;a.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:"file:"===e.location.protocol&&"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)?"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";f=e.getElementsByTagName("script")[0];f.parentNode.insertBefore(a,f)}})(document,window.mixpanel||[]);
        /* jshint ignore:end */

        var devToken = '117dc5f4cc8a557cc5008cfbaf573bcc';
        var prodToken = 'b50666ffd773b77c81b179d392f44698';
        var productionHost = 'templatefarm.io';
        var devProjectName = "Template_Farm_Dev";

        if (window.location.hostname.toLowerCase().search(productionHost) < 0) {
            mixpanel.init(devToken);
        } else {
            mixpanel.init(prodToken);
            mixpanel.init(devToken, {}, devProjectName);
        }

    })

    .factory('MixpanelService', ['Session',function (Session) {
        var service = {};

        function addCommonProperties(properties){

            if(Session.user){
                properties["user id"] = Session.user.getId();
                properties["full name"] = Session.user.getFullName();
            }
            if(Session.farm){
                properties["farm name"] = Session.farm.name;
                properties["farm id"] = Session.farm._id;
            }

            return properties;
        }


        service.sendEvent = function(event, properties){
            try {
                event = event.toLowerCase();
                properties = properties || {};
                if (Session.user) {
                    mixpanel.identify(Session.user.getId());
                }
                properties = addCommonProperties(properties);
                mixpanel.track(event, properties);
            } catch(err){
                console.log("Failed to send MX event");
            }
        };

        service.sendDevEvent = function(event, properties){
            try {
                event = event.toLowerCase();
                properties = properties || {};
                if (Session.user) {
                    if (mixpanel.Template_Farm_Dev) {
                        mixpanel.Template_Farm_Dev.identify(Session.user.getId());
                    } else {
                        mixpanel.identify(Session.user.getId());
                    }
                }
                properties = addCommonProperties(properties);
                if (mixpanel.Template_Farm_Dev) {
                    mixpanel.Template_Farm_Dev.track(event, properties);
                } else {
                    mixpanel.track(event, properties);
                }
            } catch(err){
                console.log("Failed to send MX event");
            }
        };


        service.setUser = function(){
            if(!Session.user){return;}

            data = {};
            var user = Session.user;

            if(user.local){
                if(user.local.email){
                    data.$email = user.local.email;
                }
                if(user.local.first_name){
                    data.$first_name = user.local.first_name;
                }
                if(user.local.last_name){
                    data.$last_name = user.local.last_name;
                }
                data.$name = user.getFullName();

                if(user.local.company){
                    data.company = user.local.company;
                }
            }
            mixpanel.people.set(data);
            mixpanel.people.set_once('$created', new Date());
            mixpanel.identify(user.getId());
        };
        service.setAlias = function(alias){
            mixpanel.alias(alias);
        };

        return service;
    }])


    .directive('mxEvent', ['MixpanelService', function(MixpanelService){
        return {
            restrict    : 'A',
            scope       : {
                mxEvent : "@",
                mxData  : "="
            },
            link        : function(scope, element, attr){
                element.bind('click', function(e){
                    MixpanelService.sendEvent(scope.mxEvent, scope.mxData);
                });

            }
        };
    }])

    .directive('mxDevEvent', ['MixpanelService', function(MixpanelService){
        return {
            restrict    : 'A',
            scope       : {
                mxDevEvent : "@",
                mxData  : "="
            },
            link        : function(scope, element, attr){
                element.bind('click', function(e){
                    MixpanelService.sendDevEvent(scope.mxEvent, scope.mxData);
                });

            }
        };
    }])

;
